<template>
  <apexChart
    width="110px"
    height="100px"
    type="area"
    :options="options"
    :series="series"
  >
  </apexChart>
</template>

<script>
export default {
  name: "AreaChart",
  data: () => ({
    options: {
      chart: {
        type: "area",
        toolbar: {
          show: false,
        },
      },
      xaxis: {
        labels: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
      },
      yaxis: {
        labels: {
          show: false,
        },
      },
      grid: {
        show: false,
      },
      dataLabels: {
        enabled: false,
      },
      colors: ["#039de9"],
      stroke: {
        width: 3,
        color: "#039de9",
      },
      fill: {
        type: "gradient",
        opacity: 0.1,
        gradient: {
          opacityFrom: 0.5,
          opacityTo: 0.1,
          gradientToColors: ["#039de9"],
          
        },
      },
    },
    series: [
      {
        name: "Series 1",
        data: [5, 20, 16, 18, 15, 22, 20, 24, 19, 16],
      },
    ],
  }),
};
</script>
